import { Box, Stack, CircularProgress } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppLogoLightMode from "src/assets/images/drugvlab_logo_light_mode.svg";
import AppLogoDarkMode from "src/assets/images/drugvlab_logo_dark_mode.svg";
import "src/styles/Splash.css";

// 앱 초기 로딩 화면 정의
function Splash() {

  // 다크 모드 여부 감지
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////// 페이지 렌더링 ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="breathing-div">
      <Box
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <img
              src={prefersDarkMode ? AppLogoDarkMode : AppLogoLightMode}
              alt="Loading..."
              style={{ width: "300px", paddingLeft: "22px" }}
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        </Stack>
      </Box>
    </div>
  );
}

export default Splash;
